import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import BugReportButton from "./components/BugReportButton";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import Overview from "./pages/Overview";
import Tools from "./pages/Tools";
import OrgManagement from "./pages/OrgManagement";
import InventoryPage from "./pages/inventory/InventoryPage";
import SalesPage from "./pages/sales/SalesPage";
import FeedbackPage from "./pages/feedback/FeedbackPage";
import POSTerminal from "./pages/pos/POSTerminal";
import Settings from "./pages/Settings";
import "./styles/global.css";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="sales" element={<SalesPage />} />
            <Route path="pos" element={<POSTerminal />} />
            <Route path="tools" element={<Tools />} />
            <Route path="organization" element={<OrgManagement />} />
            <Route path="feedback" element={<FeedbackPage />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>

        <BugReportButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
